// Slick carousel initialization for the server-rendered homepage.
//
// The migrated Razor partials emit the carousel slide markup with a `data-slick="<type>"`
// marker. Here we initialize jQuery slick (loaded globally by _LayoutSite) on each one,
// reproducing the exact options each Angular component used via its appSlick directive.

const ARROWS = {
  nextArrow:
    '<button type="button" data-role="none" class="next carouselArrow" aria-label="לשקופית הבאה" role="button"></button>',
  prevArrow:
    '<button type="button" data-role="none" class="prev carouselArrow" aria-label="לשקופית הקודמת" role="button"></button>'
};

const OPTIONS_BY_TYPE = {
  // app-general-banner (options mirror general-banner.component.ts exactly).
  // NB: the banner's full width is fixed in CSS (.bannerCarusel .slick-list, see _home.scss) —
  // without it slick measures a collapsed list and renders a ~319px-wide slide on desktop.
  banner: el => ({
    rtl: true,
    mobileFirst: true,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: el.getAttribute('data-autoplay') === 'true',
    autoplaySpeed: (parseInt(el.getAttribute('data-duration'), 10) || 0) * 1000,
    ...ARROWS
  }),

  // app-talents-carousel
  talents: () => ({
    rtl: true,
    mobileFirst: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '40px',
    ...ARROWS,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3, centerMode: true, centerPadding: '50px' } },
      { breakpoint: 1200, settings: { arrows: true, slidesToShow: 6, centerMode: false, centerPadding: '0px' } }
    ]
  }),

  // app-video-carousel
  video: () => ({
    rtl: true,
    mobileFirst: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '20px',
    ...ARROWS,
    responsive: [
      { breakpoint: 767, settings: { slidesToShow: 1, arrows: false, centerPadding: '25px' } },
      { breakpoint: 1200, settings: { slidesToShow: 1, arrows: true, draggable: false, centerPadding: '390px' } }
    ]
  }),

  // app-recently-aired
  recent: () => ({
    rtl: true,
    mobileFirst: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '20px',
    ...ARROWS,
    responsive: [
      { breakpoint: 767, settings: { slidesToShow: 2, arrows: true, centerMode: false, centerPadding: '0' } },
      { breakpoint: 1200, settings: { slidesToShow: 3, arrows: true, centerMode: false, centerPadding: '0px' } },
      { breakpoint: 1600, settings: { slidesToShow: 4, arrows: true, centerMode: false, centerPadding: '0px' } }
    ]
  })
};

export function initCarousels() {
  const $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.slick) return;

  const initialized = [];
  document.querySelectorAll('[data-slick]').forEach(el => {
    const make = OPTIONS_BY_TYPE[el.getAttribute('data-slick')];
    if (!make) return;

    const $el = $(el);
    if ($el.hasClass('slick-initialized')) return;

    $el.slick(make(el));
    initialized.push($el);
  });

  // Slick caches slide widths at init. If a track init's before layout has settled
  // (e.g. the banner, which has no responsive breakpoints to force a recompute), it can
  // cache a too-narrow slide width. Recompute once layout is final.
  const refresh = () => initialized.forEach($el => $el.slick('setPosition'));
  requestAnimationFrame(refresh);
  window.addEventListener('load', refresh);
}
